import React, { useMemo } from 'react';

import { Card, Flex, Tag } from 'antd-v5';
import isEmpty from 'lodash/isEmpty';
import { Text } from 'scouting-ui/lib';

import type { CounselorYouth } from '@appTypes/esb';
import { PersonAvatar } from '@shared/components';
import { getPreferredName } from '@shared/utils/preferredName';

import styles from './MBCClassModal.module.scss';

type Props = {
  onSelect: (memberId: number) => void;
  selectIcon: React.ReactNode;
  persons: CounselorYouth[];
  emptyListTitle: React.ReactNode;
  emptyListDsc: React.ReactNode;
  searchStr: string;
};

export const MovePerson: React.FC<Props> = ({
  persons,
  selectIcon,
  onSelect,
  emptyListTitle,
  emptyListDsc,
  searchStr,
}) => {
  const filteredPersons = useMemo(() => {
    if (!searchStr) return persons;
    return persons.filter(({ firstName, lastName }) =>
      `${firstName} ${lastName}`
        .toLowerCase()
        .includes(searchStr.toLowerCase()),
    );
  }, [searchStr, persons]);

  const handleOnSelect = (memberId: number) => () => {
    onSelect(memberId);
  };

  return (
    <Card className={styles.listContainer}>
      {(emptyListTitle || emptyListDsc) && isEmpty(filteredPersons) ? (
        <Flex vertical align="center">
          <Text font="body-body-2">{emptyListTitle}</Text>
          <Text font="body-body-3">{emptyListDsc}</Text>
        </Flex>
      ) : (
        <Flex vertical gap={4}>
          {filteredPersons.map(person => (
            <Tag
              key={person.memberId}
              bordered={false}
              className={styles.userTag}
              onClick={handleOnSelect(person.memberId)}
            >
              <Flex align="center" justify="stretch">
                <PersonAvatar
                  className={styles.userIcon}
                  isAdult={false}
                  gender={person.gender}
                />
                <span>{getPreferredName(person)}</span>
                <div className={styles.addIcon}>{selectIcon}</div>
              </Flex>
            </Tag>
          ))}
        </Flex>
      )}
    </Card>
  );
};
